import { ApiClientHr } from 'app/service/api-service'
import { UnitTypeEndPoint } from './constant'

export const requestGetUnitTypeAllManagement = () =>
  ApiClientHr.Get({
    url: `${UnitTypeEndPoint.UnitTypeManagement.request}/get-all`,
    params: {},
  })
